// Internet Explorer 11 requires polyfills and partially supported by this project.
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import './instrument';
import './styles/app-base.css';
import './styles/app-components.css';
import { createRoot } from 'react-dom/client';
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import posthog, { initializePostHog } from './posthog';

const container = document.getElementById('root');
const root = createRoot(container as Element);
const posthogConfigured = initializePostHog();
const app = <App />;
root.render(
  posthogConfigured ? (
    <PostHogProvider client={posthog}>
      <PostHogErrorBoundary>{app}</PostHogErrorBoundary>
    </PostHogProvider>
  ) : (
    app
  ),
);

reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
